import React from "react";

const Computer = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
            fill={fill}
            d="M19.6 26.86v3.18H26v3.182H10v-3.181h6.4V26.86H3.587a1.605 1.605 0 0 1-1.128-.474A1.587 1.587 0 0 1 2 25.258V4.602C2 3.717 2.728 3 3.587 3h28.826C33.29 3 34 3.714 34 4.602v20.656c0 .884-.728 1.602-1.587 1.602H19.6Z"
        />
    </svg>
);

export default Computer;